<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.unidadeExterna"
        ref="RkmDataTable"
        sort-by="nomeFantasia"
    >
        <template v-slot:cell(actions)="row">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-unidade-externa-edit', params: { id: row.item.id } })"
                color="primary"
                authorize="update-cadastro-unidade-externa"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(row.item)"
                color="danger"
                authorize="destroy-cadastro-unidade-externa"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {
        this.repositories.unidadeExterna = this.getConectaSusRepository('cadastro.estabelecimento.unidadeExterna')
    },
    activated() {
        this.$refs.RkmDataTable.refresh()
    },
    data: () => ({
        fields: [
            { name: 'nome_fantasia', key: 'nomeFantasia', label: 'Nome Fantasia', searchable: true, sortable: true },
            { name: 'municipio.nome', key: 'municipioNome', label: 'Município', searchable: true, sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min' },
        ],
        repositories: {},
    }),
    methods: {
        handleDestroy(item) {
            const destroy = () => this.repositories.unidadeExterna.destroy(item.id).then(() => {
                this.$refs.RkmDataTable.refresh()
            })

            this.showDeleteConfirmation('Deseja realmente excluir a unidade externa?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ]
}
</script>